import React from 'react';
import {BASE, BASE_HTTP, UPLOAD_FILE} from "../../api/Api";
import axios from 'axios';
import LoadingButton from "./LoadingButton";
import {get} from "../../utils/helpers";
import {OverlayTrigger, ProgressBar} from "react-bootstrap";

import {toast} from "react-toastify";
import Tooltip from "react-bootstrap/Tooltip";


export default function FileInput(props){

    const fieldValue = props.field.value;
    const form = props.form;
    const field = props.field;

    const [selectedFile,setSelectedFile] = React.useState();
    const [isUploading,setIsUploading] = React.useState();

    const [uploadPercentage,setUploadPercentage] = React.useState();
    const [uploadError,setUploadError] = React.useState();

    const cancelToken = React.useRef(undefined);

    function setFieldValue(image){
        props.form.setFieldValue(props.field.name,image.id);
    }

    function onUploadProgress(progressEvent){

        const percentage = (progressEvent.loaded/progressEvent.total) * 100;

        console.log('upload percentage',percentage)

        setUploadPercentage(percentage);

    }

    function cancelUpload(){
        if(cancelToken.current)
            cancelToken.current('Opération annulé');

        cancelToken.current = undefined;
        setSelectedFile();
        setUploadPercentage();
        setIsUploading(false);

    }

    async function uploadFile(){

        setUploadError()

        const formData = new FormData();

        formData.append('file',selectedFile);

        try {

            setIsUploading(true);

            const response = await axios.post(
                UPLOAD_FILE,
                formData,
                {

                    onUploadProgress: (progressEvent)=>{

                        onUploadProgress(progressEvent);

                    },

                    cancelToken: new axios.CancelToken((c) =>{

                        cancelToken.current = c;

                    })

                }
            );

            setFieldValue(response.data);

        } catch (e) {


            cancelToken.current = undefined;
            setUploadPercentage();

            if(axios.isCancel(e)){
                console.log(e);

                return;
            }

            setUploadError(e)

            //TODO: Display some error
            console.log(e);

        } finally {
            setIsUploading(false);
        }

    }

    React.useEffect(
        () => {

            if(selectedFile)
                uploadFile();

        },[selectedFile]
    );

    function onFileInputChange(event){
        console.log('targeted file',event.target.files)

        if(event.target.files[0].size > Math.pow(10,7)){

            toast.error('Vous ne pouvez pas envoyer des fichiers de plus de 10mb', {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

            return;
        }

        setSelectedFile(event.target.files[0]);
    }

    return (
        <span>

            {
                !isUploading && (
                    <label className={'d-block'}>

                        <div>
                    <span>
                        <span>{props.label || props.placeholder}</span> <br/>
                    </span>
                        </div>

                        {

                            !fieldValue && (

                                <div className={'btn btn-light-primary'}>
                                    Sélectionner un fichier
                                </div>

                            )

                        }

                        <input onChange={onFileInputChange} type="file" className={'d-none'}/>

                        {
                            uploadError && uploadError.response && uploadError.response.status === 413 && (
                                <div className="small text-danger font-weight-bold">
                                    Fichier trop volumineux
                                </div>
                            )
                        }

                        {
                            uploadError && uploadError.response && uploadError.response.status === 422 && (
                                <div className="small text-danger font-weight-bold">
                                    {
                                        uploadError.response.data.errors.file.join(' ')
                                    }
                                </div>
                            )
                        }

                        {
                            uploadError && uploadError.response && uploadError.response.status === 500 && (
                                <div className="small text-danger font-weight-bold">
                                    Une erreur survenue est inconnue
                                </div>
                            )
                        }

                        {
                            uploadError && !uploadError.response && (
                                <div className="small text-danger font-weight-bold">
                                    Impossible d'envoyer le fichier, vérifier votre connexion à internet
                                </div>
                            )
                        }

                    </label>
                )
            }

            {
                isUploading && (
                    <div className={'d-flex align-items-center mt-3'}>

                        <div className={'flex-grow-1'}>
                            <ProgressBar animated now={uploadPercentage} />
                        </div>

                        <div onClick={cancelUpload} className={'btn btn-icon ml-2 btn-light-danger'}>
                            <i className={'flaticon2-delete'}></i>
                        </div>

                    </div>
                    )
            }


            {

                fieldValue && (

                    <>

                        <LoadingButton onClick={()=>{setFieldValue(props.field.name,'')}} className={'btn btn-light-primary mx-2'}>

                            {
                                selectedFile && (
                                    <>
                                        {
                                            selectedFile.name.length > 15 ?
                                                (
                                                    <OverlayTrigger
                                                        placement="bottom"
                                                        overlay={
                                                            <Tooltip id="latest-project">{selectedFile.name}</Tooltip>
                                                        }
                                                    >
                                            <span>
                                                {`${selectedFile.name.substring(0,15)}...`}
                                            </span>
                                                    </OverlayTrigger>)
                                                : selectedFile.name
                                        }
                                    </>
                                )
                            }

                            {
                                !selectedFile && (
                                    <>{'fichier pré-chargé'.toUpperCase()}</>
                                )
                            }


                             &nbsp;<span className="small">Cliquez pour annuler</span>
                        </LoadingButton>

                        <a href={`${BASE_HTTP}/file/view/${fieldValue}`} target={'_blank'}>
                            <div className={'btn btn-small btn-light-primary'}>
                                VOIR
                            </div>
                        </a>



                    </>

                )

            }

            {

                get(form.errors,field.name,undefined) && (

                    <div className={'small text-danger font-weight-bold'}>
                        {get(form.errors,field.name,undefined) }
                    </div>

                )

            }


        </span>
    );
}